import { ShieldCheck } from "lucide-react";
import { AgentPulseIcon } from "./AgentPulseIcon";
import { OffrLogo } from "./OffrLogo";

const jobs = [
  ["N", "Northstar", "Frontend Engineer", "Ready", "blue"],
  ["P", "Paperplane", "Product Engineer", "Ready", "violet"],
  ["K", "Kernel", "Software Engineer", "Review", "slate"],
  ["D", "Daybreak", "UI Engineer", "Queued", "cobalt"]
] as const;

export function DashboardExtensionPreview() {
  return (
    <aside className="dashboard-extension-preview" aria-label="Synthetic preview of the Offr browser extension">
      <header>
        <OffrLogo />
        <span><i /> agent ready</span>
      </header>
      <div className="dashboard-extension-preview__title">
        <span>Selected applications</span>
        <strong>4 tabs</strong>
      </div>
      <div className="dashboard-extension-preview__queue">
        {jobs.map(([mark, company, role, status, tone]) => (
          <div key={company}>
            <i className={`dashboard-extension-preview__mark dashboard-extension-preview__mark--${tone}`}>{mark}</i>
            <span><strong>{company}</strong><small>{role}</small></span>
            <b>{status}</b>
          </div>
        ))}
      </div>
      <div className="dashboard-extension-preview__apply">
        <AgentPulseIcon size={16} /> Apply all (4)
      </div>
      <p><ShieldCheck size={12} aria-hidden="true" /> Pauses before submission</p>
    </aside>
  );
}
